import { observer } from 'mobx-react-lite';
import PreviewBodyElement from './PreviewBodyElement';
import type { PreviewBodyElementProps } from './types';

export type { PreviewBodyElementProps };
export default observer(PreviewBodyElement);
